import { render, staticRenderFns } from "./imageButton.vue?vue&type=template&id=38096029&scoped=true&"
import script from "./imageButton.vue?vue&type=script&lang=js&"
export * from "./imageButton.vue?vue&type=script&lang=js&"
import style0 from "./imageButton.vue?vue&type=style&index=0&id=38096029&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38096029",
  null
  
)

export default component.exports